import { useState } from "react";
import { KeyRound, ShieldAlert } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { toast } from "sonner";

export function ForcedPasswordChange() {
  const [cur, setCur] = useState("");
  const [nw, setNw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nw.length < 8) return toast.error("New password must be at least 8 characters");
    if (nw !== confirm) return toast.error("New password and confirmation do not match");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/change-password", { current_password: cur, new_password: nw });
      localStorage.setItem("smartemi_token", data.token);
      toast.success("Password updated. Welcome to ZRo Pe Admin.");
      window.location.reload();
    } catch (err) {
      toast.error(apiError(err));
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B132B] flex items-center justify-center px-4" data-testid="forced-password-change">
      <div className="w-full max-w-md rounded-2xl bg-white p-7 shadow-2xl">
        <div className="mb-4 flex items-center gap-3">
          <div className="grid h-11 w-11 place-items-center rounded-full bg-amber-100 text-amber-600"><ShieldAlert size={20} /></div>
          <div>
            <h1 className="font-display text-lg font-bold text-[#0B132B]">Set a new password</h1>
            <p className="text-xs text-slate-500">For security, you must change your temporary password before continuing.</p>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="text-xs font-semibold text-slate-600">Temporary password</label>
            <input type="password" value={cur} onChange={(e) => setCur(e.target.value)} required data-testid="fpc-current"
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-[#14B8A6]" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600">New password (min 8 chars)</label>
            <input type="password" value={nw} onChange={(e) => setNw(e.target.value)} required data-testid="fpc-new"
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-[#14B8A6]" />
          </div>
          <div>
            <label className="text-xs font-semibold text-slate-600">Confirm new password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="fpc-confirm"
              className="mt-1 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm outline-none focus:border-[#14B8A6]" />
          </div>
          <button type="submit" disabled={busy} data-testid="fpc-submit"
            className="mt-2 flex w-full items-center justify-center gap-2 rounded-lg bg-[#14B8A6] px-4 py-2.5 text-sm font-semibold text-white hover:bg-[#0f9c8c] disabled:opacity-60">
            <KeyRound size={16} /> {busy ? "Updating…" : "Update password & continue"}
          </button>
        </form>
      </div>
    </div>
  );
}
